import React, { ReactNode } from 'react';

const BasePage = (props: { children: ReactNode }) =>(
    <div className="wrapper" style={{background: '#f5f7fa'}}>
        { props.children }
    </div>
)

export default BasePage;
